import React, { ReactElement, forwardRef, useImperativeHandle } from 'react';
import { KImage, PageContext } from '@/component/RtlLayout';
import { convertStyles } from '@kibt/krn-utils';

import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

import imgCoin from '@/assets/images_detail/icon-down.png';

type IProps = {};
const ArrowRight = forwardRef(function specLine(props: IProps, ref): ReactElement {
    // const { } = props;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useImperativeHandle(
        ref,
        () => {
            return {
                // 暴露出去的方法,
            };
        },
        []
    );
    return (
        <PageContext.Provider value={{ Styles }}>
            <KImage rtlClassName={'arrow-right'} source={imgCoin} />
        </PageContext.Provider>
    );
});
export default ArrowRight;
